module.exports = __webpack_public_path__ + "img/technicalExpertConsultant.ff12b8f7.svg";